/**
 * Feature Flags
 * ---------------------------------------------
 * Used to only show features to users that
 * have the required flags.
 */

export const MARKETPLACE = 'marketplace'
export const ROOM_LIMIT_MAX_ATTENDEES = 'rooms.limit_max_attendees'
export const BROADCASTS = 'broadcasts'
export const SMS = 'sms'
export const PROMOTER = 'promoter'
export const ZOOM_ATTENDANCE = 'zoomAttendance'
export const TOWNHALL = 'townhall'
export const SAGEHUB = 'sagehub'
export const OBIE = 'obie'
export const MARKETPLACE_UPSELL = 'marketplace_upsell'
export const MARKETPLACE_CUSTOM_PAGE = 'marketplace_custom_page'
export const MARKETPLACE_NEW_LAYOUT = 'marketplace_new_layout'

/**
 * External services flag like chat.obv.io
 */
export const CENTRAL_CONTROL = 'central_control'

export type FeatureFlag =
  | typeof MARKETPLACE
  | typeof ROOM_LIMIT_MAX_ATTENDEES
  | typeof BROADCASTS
  | typeof SMS
  | typeof PROMOTER
  | typeof ZOOM_ATTENDANCE
  | typeof TOWNHALL
  | typeof SAGEHUB
  | typeof OBIE
  | typeof MARKETPLACE_UPSELL
  | typeof MARKETPLACE_CUSTOM_PAGE
  | typeof MARKETPLACE_NEW_LAYOUT
  | typeof CENTRAL_CONTROL
